module.exports = __webpack_public_path__ + "static/media/comsats.c2d7f27a.jpg";